import React from 'react';
import { MONO, SANS } from '../../constants/fonts';

const styles = {
  wrap: {
    maxWidth: 520,
    margin: '80px auto',
    padding: 32,
    background: '#fff',
    border: '1px solid #e5e5ea',
    borderRadius: 16,
    fontFamily: SANS,
    textAlign: 'center',
  },
  title: {
    fontFamily: MONO,
    fontSize: '1.1rem',
    marginBottom: 10,
  },
  text: {
    fontSize: '0.88rem',
    color: '#777',
    lineHeight: 1.6,
    margin: '0 0 20px',
  },
  button: {
    padding: '10px 18px',
    borderRadius: 8,
    border: '1px solid #d5d5da',
    background: '#fff',
    color: '#333',
    fontSize: '0.88rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  details: {
    marginTop: 20,
    textAlign: 'left',
    fontFamily: MONO,
    fontSize: '0.72rem',
    color: '#999',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  },
};

// Without this, a render error anywhere unmounts the whole React tree and the
// visitor gets a blank page — the marketing site included. Wrapping a subtree
// contains the damage to that subtree instead.
//
// Has to be a class: there's no hook equivalent of componentDidCatch.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Nothing collects these yet, so the console is the only record.
    console.error('Render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={styles.wrap}>
        <div style={styles.title}>{this.props.title || 'Something went wrong'}</div>
        <p style={styles.text}>
          {this.props.message || 'This part of the page failed to load. Reloading usually fixes it.'}
        </p>
        <button type="button" style={styles.button} onClick={() => window.location.reload()}>
          Reload the page
        </button>
        {/* Only in development: visitors get the friendly message, you get the stack. */}
        {process.env.NODE_ENV === 'development' && (
          <div style={styles.details}>{String(this.state.error?.stack || this.state.error)}</div>
        )}
      </div>
    );
  }
}
